__turbopack_context__.v({
  "colPrice": "comparisongrid-module-scss-module__Enw4ta__colPrice",
  "dash": "comparisongrid-module-scss-module__Enw4ta__dash",
  "desktopTh": "comparisongrid-module-scss-module__Enw4ta__desktopTh",
  "leftAlign": "comparisongrid-module-scss-module__Enw4ta__leftAlign",
  "mobileTh": "comparisongrid-module-scss-module__Enw4ta__mobileTh",
  "planHeaderWrapper": "comparisongrid-module-scss-module__Enw4ta__planHeaderWrapper",
  "priceHeader": "comparisongrid-module-scss-module__Enw4ta__priceHeader",
  "rowChannels": "comparisongrid-module-scss-module__Enw4ta__rowChannels",
  "rowHead": "comparisongrid-module-scss-module__Enw4ta__rowHead",
  "rowPrice": "comparisongrid-module-scss-module__Enw4ta__rowPrice",
  "showDesktop": "comparisongrid-module-scss-module__Enw4ta__showDesktop",
  "showMobile": "comparisongrid-module-scss-module__Enw4ta__showMobile",
  "spaciousVariant": "comparisongrid-module-scss-module__Enw4ta__spaciousVariant",
  "table": "comparisongrid-module-scss-module__Enw4ta__table",
  "tableWrapper": "comparisongrid-module-scss-module__Enw4ta__tableWrapper",
  "tooltip": "comparisongrid-module-scss-module__Enw4ta__tooltip",
  "tooltipContent": "comparisongrid-module-scss-module__Enw4ta__tooltipContent",
  "topRowMobile": "comparisongrid-module-scss-module__Enw4ta__topRowMobile",
  "totalLink": "comparisongrid-module-scss-module__Enw4ta__totalLink",
});
